import { extend } from 'vee-validate';
import number_of_electrical_feeds from './rules/number_of_electrical_feeds';

extend('number_of_electrical_feeds', {

    validate: (value, { numberOfElectricalFeedsStart, numberOfElectricalFeedsMiddle, numberOfElectricalFeedsEnd, numberOfElectricalFeedsPerLine }) => {
        return number_of_electrical_feeds({value, numberOfElectricalFeedsStart, numberOfElectricalFeedsMiddle, numberOfElectricalFeedsEnd, numberOfElectricalFeedsPerLine});
    },
    params: ['numberOfElectricalFeedsStart', 'numberOfElectricalFeedsMiddle', 'numberOfElectricalFeedsEnd', 'numberOfElectricalFeedsPerLine'],
    message: 'Needed quantity of elecrtical feeds'
});

extend('germanFloat', {
    validate: (value) => {
        // Convert German float to standard float format
        // Check if the converted value is numeric
        return !isNaN(parseFloat(value)) && isFinite(value);
    },
    message: 'This field must be a valid number'
});

